const RingSelectSelectors = {
  getRingSelect(store) {
    return store.ringSelect;
  },
};

export { RingSelectSelectors };
